import React from "react";
import {Row,} from "reactstrap";
import Stepper from "./steps/Stepper";


const BasicIndex = (props) => {
    const timestamp=new Date().toString()
    return (
        <>
            <div className="content">
                <Row className={"justify-content-center"}>
                    <Stepper timestamp={timestamp} step={2} category={11}/>
                </Row>
            </div>
        </>
    );
}

export default BasicIndex;